import { c as _c } from "react/compiler-runtime";
import { styled } from '@precis-digital/kurama/utils';
import Typography from '@precis-digital/kurama/Typography';
import React, { type ReactElement } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';
import { buildCopilotAiSubtleLinearGradient } from 'shared/copilot/utils/copilotElementHighlight';
interface CopilotPrePromptButtonProps {
  icon: React.ReactNode;
  label: string;
  message?: string;
}
const CopilotPrePromptButton = t0 => {
  const $ = _c(12);
  const {
    icon,
    label,
    message
  } = t0;
  const {
    sendUserMessage
  } = useCopilot();
  let t1;
  if ($[0] !== label || $[1] !== message || $[2] !== sendUserMessage) {
    t1 = () => {
      sendUserMessage(message ?? label, {
        includeComposerAttachments: false
      });
    };
    $[0] = label;
    $[1] = message;
    $[2] = sendUserMessage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== icon) {
    t2 = <StyledGridIconContainer>{icon}</StyledGridIconContainer>;
    $[4] = icon;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== label) {
    t3 = <Typography variant="body1">{label}</Typography>;
    $[6] = label;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleClick || $[9] !== t2 || $[10] !== t3) {
    t4 = <StyledPrePromptButton onClick={handleClick} type="button">{t2}{t3}</StyledPrePromptButton>;
    $[8] = handleClick;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
const StyledPrePromptButton = styled('button')(({
  theme
}) => ({
  width: '100%',
  background: buildCopilotAiSubtleLinearGradient(theme),
  border: 'none',
  borderRadius: theme.borderRadius.medium,
  padding: '12px 16px 12px 12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  textAlign: 'left',
  color: theme.tokens.foreground.main.primary,
  '& svg': {
    color: 'currentColor'
  },
  '&:hover': {
    opacity: 0.85
  }
}));
const StyledGridIconContainer = styled('span')(() => ({
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
export default CopilotPrePromptButton;